import { render, staticRenderFns } from "./ListHotelPendingChanges.vue?vue&type=template&id=823d3282&"
import script from "./ListHotelPendingChanges.vue?vue&type=script&lang=js&"
export * from "./ListHotelPendingChanges.vue?vue&type=script&lang=js&"
import style0 from "./ListHotelPendingChanges.vue?vue&type=style&index=0&id=823d3282&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports